import React from 'react';
import { Notification } from '../provider/NotificationsProvider';

export interface NotificationsContextType {
  notifications: Notification[];
  getNotifications: () => Notification[];
  isLoading: boolean;
  error: string | null;
  clearError: () => void;
}

export const NotificationsContext =
  React.createContext<NotificationsContextType>({
    notifications: [],
    getNotifications: () => [],
    isLoading: false,
    error: null,
    clearError: () => {},
  });
